import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { UpdateQueryParams } from '@hooks';
import React, { useCallback } from 'react';
import { Space, Switch } from 'antd';

export type InactiveToggleQueryParams = { hideInactive?: boolean };

export interface InactiveToggleProps {
	checked: boolean;
	onChange: UpdateQueryParams<InactiveToggleQueryParams>;
}

export const InactiveToggle: React.FC<InactiveToggleProps> = ({ checked, onChange }) => {
	// Switch onChange passes a second argument that cannot be passed
	// When provided onChange is a setState function.
	const handleOnChange = useCallback(
		(value: boolean) => onChange({ hideInactive: !value }),
		[ onChange ]
	);

	return (
		<Space>
			<span>{ COPY_GENERIC.SHOW_INACTIVE }</span>
			<Switch
				checked={ !checked }
				onChange={ handleOnChange } />
		</Space>
	);
};
